import { render, staticRenderFns } from "./FireReport.vue?vue&type=template&id=f4960ccc&"
import script from "./FireReport.vue?vue&type=script&lang=js&"
export * from "./FireReport.vue?vue&type=script&lang=js&"
import style0 from "./FireReport.vue?vue&type=style&index=0&id=f4960ccc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports